import { Button } from "@/components/ui/button";
import { UploadCloud } from "lucide-react";

interface RoomsSectionEmptyStateProps {
  onUpload?: () => void;
  title?: string;
  description?: string;
}

export function RoomsSectionEmptyState({
  onUpload,
  title = "No room data yet",
  description = "Add documentation to create line items",
}: RoomsSectionEmptyStateProps) {
  return (
    <div className="flex flex-1 items-center justify-center px-6 py-10">
      <div className="w-full max-w-xs p-6">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-slate-900/5 ring-1 ring-slate-900/10">
          <UploadCloud className="h-6 w-6 text-slate-700" />
        </div>

        <div className="mt-4 text-center">
          <h3 className="text-base font-semibold text-slate-900">{title}</h3>
          <p className="mt-1 text-sm text-slate-600">{description}</p>
        </div>

        <Button size="lg" variant="secondary" className="mt-4 w-full" onClick={() => onUpload?.()}>
          Upload
        </Button>
      </div>
    </div>
  );
}
